<script>
	import {Pie, mixins} from 'vue-chartjs';

	export default {
		mixins: [Pie, mixins.reactiveProp],
		data() {
			return {
				chartOptions: {
					responsive: true,
					legend: {
						position: 'bottom'
					}
				}
			};
		},
		mounted() {
			this.renderChart(this.chartData, this.chartOptions);
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/charts/OnlineOffline.vue